// extracted by mini-css-extract-plugin
export default {"infoTitle":"infoTitle---aq6WJ","infoContent":"infoContent---HwTmi"};